module.exports = __webpack_public_path__ + "c2f61cff43a78070f10a8ff3b2f0a3b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/news7.jpg
// module id = 203
// module chunks = 0